import { SERVICE } from '@src/api/types/shared/serviceType';
import CommonHelmet from '@src/components/CommonHelmet';
import CompanyGuard from '@src/components/guard/CompanyGuard';
import EventList from '@src/features/company/events/EventList';
import CompanyDefaultLayout from '@src/layouts/company/CompanyDefaultLayout';

function CompanyEventList() {
  return (
    <CompanyGuard canService={[SERVICE.ENTERPRISE_PORTAL]}>
      <CompanyDefaultLayout pageName='events'>
        <CommonHelmet />
        <EventList />
      </CompanyDefaultLayout>
    </CompanyGuard>
  );
}

export default CompanyEventList;
